/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { colors, Radio as ConsumerRadio, RadioProps as ConsumerRadioProps } from '@blend/consumer-components';

export namespace Radio {
  export interface Props extends Omit<ConsumerRadioProps, 'color'> {}
}

export const Radio: React.FC<Radio.Props> = ({ ...props }) => {
  return <ConsumerRadio {...props} color={colors.reflex} />;
};
